/**
 * The team profile Injuries panel: the team's own report from sports-api
 * `/team/injuries-get`, the same source and the same shared InjuryList the
 * game detail Injuries tab uses. ISSUE-984, R6.
 */
import { useTeamInjuriesGet } from "@sportsmet/sports-sdk/private";
import { Skeleton } from "@sportsmet/ui";
import { type ReactNode, useEffect } from "react";

import { extractErrorCode, showApiError } from "../../errors/apiErrorBus";
import { InjuryList } from "../injuries/InjuryList";

export const TeamInjuriesTab = ({
  teamId,
  teamName,
  teamAbbreviation,
}: {
  teamId: string;
  teamName: string;
  teamAbbreviation: string;
}): ReactNode => {
  const read = useTeamInjuriesGet({ teamId });

  useEffect(() => {
    if (extractErrorCode(read.data) !== null) {
      showApiError(read.data, undefined, read.dataUpdatedAt);
    }
  }, [read.dataUpdatedAt, teamId]);

  if (read.isPending) {
    return (
      <div data-testid="team-injuries-loading">
        <Skeleton shape="card" />
      </div>
    );
  }

  if (extractErrorCode(read.data) !== null) {
    return (
      <div className="flex flex-col gap-4" data-testid="team-injuries-tab" />
    );
  }

  return (
    <div className="flex flex-col gap-4" data-testid="team-injuries-tab">
      <InjuryList
        hasReport={read.data?.data?.hasReport ?? false}
        entries={read.data?.data?.injuries ?? []}
        team={{ teamId, name: teamName, abbreviation: teamAbbreviation }}
      />
    </div>
  );
};
